import styled from 'styled-components';
import { Typography } from '@material-ui/core';

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e2ebf6;
  box-sizing: border-box;
  min-height: 48px;
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    min-height: auto;
  }
`;

export const ToolbarLeft = styled.div`
  display: flex;
  align-items: center;
  min-width: 220px;
  height: 100%;
  border-right: 1px solid #e2ebf6;
  box-sizing: border-box;
  @media (max-width: 600px) {
    min-width: 100%;
    border-right: none;
    border-bottom: 1px solid #e2ebf6;
    justify-content: center;
  }
`;

export const ToolbarRight = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 30px;
  @media (max-width: 600px) {
    justify-content: center;
    padding-right: 0;
    width: 100%;
    padding: 10px 0;
  }
`;

export const ToolbarTitle = styled(Typography)`
  padding: 0 40px 0 30px;
  font-weight: bold;
  @media (max-width: 600px) {
    padding: 10px 20px;
    font-size: 14px;
  }
`;
